import { forwardRef, useImperativeHandle } from 'react';
import { useEditor } from '@craftjs/core';

export interface FormValues {
  [key: string]: any;
}

export type FormValueCollectorRef = {
  getValues: () => { [key: string]: any };
};

const FormValueCollector = forwardRef<FormValueCollectorRef>((_, ref) => {
  const { query } = useEditor();

  const getValues = () => {
    const allNodes = query.getNodes();

    const values: { [key: string]: any } = {};

    Object.entries(allNodes).forEach(([id, node]) => {
      if (!node.id) return;

      const { displayName } = node.data || {};

      const props = node.data.props;
      let previewLabel;
      let fieldValue;

      switch (displayName) {
        case 'InputField':
          fieldValue = props.value || '';
          previewLabel = props.previewLabel || false;

          break;
        case 'CheckboxField':
          fieldValue = props.value ?? false;
          break;
        case 'DropdownField':
          fieldValue = props.options?.[props.selectedIndex || 0] || '';
          break;
        case 'MultilineTextbox':
          fieldValue = props.value || '';
          break;
        case 'UploadArea':
          fieldValue = props.file || null;
          break;
        case 'DatePickerField':
          fieldValue = props.selectedDate || '';
          break;
        case 'TimePickerField':
          fieldValue = props.timeValue || '';
          break;
        default:
          return;
      }

      const key = `${displayName}_${id}`;
      values[key] = {
        fieldValue,
        labelValue: props.label?.trim(),
        previewLabel: previewLabel,
      };
    });
    // setFormValues(values);
    return values;
  };

  useImperativeHandle(ref, () => ({
    getValues,
  }));

  return null; // It’s a logic-only component
});

export default FormValueCollector;
